import Phaser, { GameObjects } from 'phaser'
import '../../characters/Thief'
import Thief from "../../characters/Thief"
import {createThiefAnimations} from "../../animations/ThiefAnimation"
import {sceneEvents} from "../../events/EventsCenter"
import {Hints, hints} from "../../assets/classes/Hints"
import {Karten, karten } from "../../assets/classes/Karten"
import Officer from "../../enemies/Officer"
import {createOfficerAnimations} from "../../animations/EnemyAnimation"
import QuestionLoaderLine from '../../assets/classes/QuestionLoaderLine'
import TilesetManager from '../../scenes/Levels/TilesetManager'

var keyM

export default class Level8 extends Phaser.Scene {
    private cursors!: Phaser.Types.Input.Keyboard.CursorKeys
    private thief!: Thief
    private officers!: Phaser.Physics.Arcade.Group
    private hintNum!: number
    private karte: Karten = new Karten(8)
    private karten: Karte[] = this.karte.getKarten()
    private kartenNum!: number
    private tilesetManager!: TilesetManager

    private questionText!: string;
    private options!: string[];
    private explanation!: string;
    private randomQuestion: any;
    private rightAnswer: any;
    private questionId!: number;

    constructor() {
        super('level8')
        this.hintNum = 8
        this.kartenNum = 1
    }

    create() {
        this.cameras.main.fadeIn(500)

        // Animationen erzeugen
        createThiefAnimations(this.anims)
        createOfficerAnimations(this.anims)

        const map = this.make.tilemap({key: 'map8'})

        // TilesetManager initialisieren
        this.tilesetManager = new TilesetManager(this);
        const allLayers = this.tilesetManager.loadTilesets(map, 'otherLevel');

        // Layer erstellen
        map.createLayer(0, allLayers)
        const gebaeude = map.createLayer(1, allLayers)
        const gebaeudeMauer = map.createLayer(2, allLayers)
        const objekte = map.createLayer(3, allLayers)

        // Thief erstellen
        this.thief = this.add.thief(2000, -750, 'thief')
        if(this.thief?.body){
            this.thief.body.offset.y = 16
        }

        // Musiksteuerungstaste
        if(this.input?.keyboard){
            keyM = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.M)
        }

        // Kollision aktivieren
        objekte?.setCollisionByExclusion([-1])
        gebaeudeMauer?.setCollisionByExclusion([-1])
        gebaeude?.setCollisionByExclusion([-1])

        // Frage laden
        const questionLoader = new QuestionLoaderLine();
        questionLoader.loadQuestion(8).then(questionData => {
          this.questionText = questionData.questionText;
          this.options = questionData.options;
          this.randomQuestion = questionData;
          this.rightAnswer = questionData.rightAnswer;
          this.explanation = questionData.explanation;
          this.questionId = questionData.questionId;
          console.log("questionState", questionData);
        });

        this.cameras.main.startFollow(this.thief, true)

        // Officers-Gruppe
        this.officers = this.physics.add.group({
            classType: Officer,
            createCallback: (go) => {
                const offGo = go as Officer
                if(offGo?.body){
                    offGo.body.onCollide = true
                }
            }
        })

        let officer = this.officers.get(1800, -1050, 'officer')
        officer.setSize(30, 32)
        officer.body.offset.y = 16

        // Tür als Collider-Objekt
        var door = this.add.rectangle(1830, -1161, 150, 150)
        this.physics.add.existing(door, true)

        // Kollisionen definieren
        if(objekte) this.physics.add.collider(this.thief, objekte)
        if(gebaeudeMauer) this.physics.add.collider(this.thief, gebaeudeMauer)
        if(gebaeude) this.physics.add.collider(this.thief, gebaeude)
        if(objekte) this.physics.add.collider(this.officers, objekte)
        if(gebaeudeMauer) this.physics.add.collider(this.officers, gebaeudeMauer)
        if(gebaeude) this.physics.add.collider(this.officers, gebaeude)

        // Kollision Thief-Officer (Typen angepasst!)
        this.physics.add.collider(
            this.thief,
            this.officers,
            this.handleThiefOfficerCollision as Phaser.Types.Physics.Arcade.ArcadePhysicsCallback,
            undefined,
            this
        )

        // Kollision Thief-Tür (Typen angepasst!)
        this.physics.add.collider(
            this.thief,
            door,
            this.handleThiefDoorCollision as Phaser.Types.Physics.Arcade.ArcadePhysicsCallback,
            undefined,
            this
        )

        // Steuerungsszenen starten
        this.scene.launch('joystickTouch', { thief: this.thief });
        this.scene.launch('pausenButton', { pausedSceneKey: this.scene.key })
        this.scene.launch('mapButton')
        this.scene.launch('musikButton')
        this.scene.launch("stopwatchscene")
        this.scene.launch('equipment')

        // Levelwechsel-Events
        this.events.once('resume', (sys, data) => {
            if (data.bool) {
                this.scene.stop()
                this.scene.run('level9')
            } else if (!data.bool) {
                this.hintNum = 8
                this.kartenNum = 0
                this.scene.stop()
                this.scene.start()
            }
        })

        // Hinweise anzeigen
        sceneEvents.on('getHint', () => {
            if (this.scene.isActive('karten')) {
                this.scene.setVisible(false, 'karten')
            }
            this.scene.launch('hints', { content: hints[this.hintNum].content })
        })

        // Karten anzeigen
        sceneEvents.on('getKarten', () => {
            if (this.scene.isActive('hints')) {
                this.scene.setVisible(false, 'hints')
                this.scene.launch('equipment')
            }
            this.scene.launch('karten', { content: this.karten[0].content })
        })
    }

    // Tür-Kollision: Typen angepasst!
    handleThiefDoorCollision(
        obj1: Phaser.Types.Physics.Arcade.GameObjectWithBody,
        obj2: Phaser.Types.Physics.Arcade.GameObjectWithBody
    ) {
        sceneEvents.off('openQuestion'); // Doppelte Listener vermeiden

        this.thief.setQuestion();

        sceneEvents.once('openQuestion', () => {
            this.scene.pause();
            this.cleanUpScenes();
            this.scene.launch('questionLineScene', {
                question: this.questionText,
                answer1: this.options[0],
                answer2: this.options[1],
                answer3: this.options[2],
                answer4: this.options[3],
                answer5: this.options[4],
                answer6: this.options[5],
                rightAnswer: this.rightAnswer,
                explanation: this.explanation,
                caller: 'level8'
            });

            // Frage-Antwort-Logik
            sceneEvents.once('questionAnswered', (isCorrect) => {
                if (isCorrect) {
                    this.cleanUpScenes();
                    this.scene.start('level9');
                } else {
                    this.scene.resume();
                }
            });
        });
    }

    // Officer-Kollision: Typen angepasst!
    handleThiefOfficerCollision(
        obj1: Phaser.Types.Physics.Arcade.GameObjectWithBody,
        obj2: Phaser.Types.Physics.Arcade.GameObjectWithBody
    ) {
        this.events.removeListener('resume');
        this.cleanUpScenes();
        this.scene.start('gameOver', { caller: 'level8' });
    }

    // Hilfsfunktion: Szenen aufräumen
    cleanUpScenes() {
        this.scene.stop('mapButton');
        this.scene.stop('karten');
        this.scene.stop('joystickTouch');
        this.scene.stop('hints');
        this.scene.stop('equipment');
        this.scene.stop('musikButton');
        this.scene.stop('stopwatchscene');
        sceneEvents.off('getHint');
        sceneEvents.off('getKarten');
    }
}
